// card versions: house-v1 house-v2 house-v3 cards classic-a classic-b classic-c grid-v2
// card sizes: 5
// ============================================================
// AYASA: the model-card versions outside the shop
// (snippets/ayasa-card-versions.liquid)
//
// Studio, Settings, model cards picks one version of the model card per
// placement: the homepage (home), the product page's Keep exploring (explore)
// and the artist rails (artist), written as AYASA_CFG.cardVersions. A
// placement left at the house card has no entry, and then nothing here runs.
//
// The house cards are drawn by ayasa-core-N.js. This file changes each one IN
// PLACE into the chosen version: the same element, so everything core already
// holds on to keeps working (the tonality filters and the Elements heading,
// the current-scale mark, the reveal and scroll-spotlight observers, the
// hearts). It is loaded deferred straight after the core script, so the cards
// exist, and before the card player module, so each pan mounts on the changed
// card.
//
// The house card comes in three versions, which differ only in the link at
// the right of its foot. Each placement's own today is one of them, so only
// the other two ever run on it:
//   house-v1    "View in shop" (the homepage today)
//   house-v2    the price (Keep exploring and the artist rails today)
//   house-v3    "Details" with the price under it
//
// The other versions are Roy's shop cards (cardHTML and classicCard in
// ayasa-shop-12.js, their looks copied into ayasa-card-versions-2.css):
//   cards       the big card: the pan bigger with its runs under it, the notes
//               counted in blue, Details beside Full Player, and a foot with
//               the ship date on two lines, the price and a round cart
//   classic-a/b/c  the house card, the whole card opening the instrument
//               ("View details"), and in its top corner the price, a round
//               cart and the heart, in the order the letter names
// Outside the shop there is no quick-add panel, so the cart is a link to the
// instrument's page at its buy box. Until the shop and this file share one
// renderer, studio/card-versions-drift.test.mjs catches a change to Roy's copy.
//
// Each version's instrument can be drawn bigger or smaller than today
// (AYASA_CFG.cardSizes, { version: factor }, the shop's grid tile and rows
// included), and so can its title, subtitle and details text (the keys
// "<version>.title", ".sub" and ".details", generation 6: "card sizes: 2").
// The factor is set on the page as --cv-pan-<version> (the text ones as
// --cv-tt-, --cv-ts- and --cv-td-<version>), and the
// stylesheet repeats every rule that sizes the pan with it. With no size set,
// nothing is written; the second line says this file can do it.
//
// The shop's grid tile v2 (grid-v2) is Roy's grid tile with the big card's
// round cart in place of "Add to cart" (Ralf, 30-09). The shop draws the tile
// as it always does; this file puts html.cv-round-cart on the page when the
// screen's grid version is v2 (AYASA_CFG.cardVersions.shopGrid on a computer,
// .shopPhone on a phone), and the stylesheet turns the button round.
//
// The first line lists the versions this file can draw. The studio reads it to
// decide what may be saved, so a new version adds its id there, in a new
// generation of this file (the preview's cache ignores query strings).
// Nothing inside #ayshop is ever touched: the shop page draws its own.
// ============================================================
(() => {
  const IDS = ["house-v1", "house-v2", "house-v3", "cards", "classic-a", "classic-b", "classic-c"];
  // the house card each placement draws today, which needs nothing from here
  const TODAY = { home: "house-v1", explore: "house-v2", artist: "house-v2" };
  // the house versions: what the link at the right of the foot says
  const LINK = { "house-v1": "shop", "house-v2": "price", "house-v3": "details" };
  // where each placement's house cards live; each is a grid of .model-card
  const PLACES = {
    home: ["#premiumGrid", "#elementsGrid"],
    explore: ["#scaleNav .scale-cards"],
    artist: ["#artistPlays .scale-cards"],
  };
  // corner cards: the order of the price, the cart and the heart
  const CORNER = { "classic-a": ["price", "cart", "heart"], "classic-b": ["cart", "price", "heart"], "classic-c": ["heart", "cart", "price"] };
  // Roy's ?phone= and ?desktop= work on these hosts only, and so does ?cards=
  const PREVIEW = /^(preview\.ayasa-studio\.com|127\.0\.0\.1|localhost)$/;
  const has = (o, k) => Object.prototype.hasOwnProperty.call(o, k);

  // the same drawing and formats as the shop's cards
  const CART = `<svg class="cart" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.8 2.5h2.4l2 10.2h9.6l1.9-7.2H5.1"/><circle cx="7.6" cy="16.4" r="1.2"/><circle cx="14.4" cy="16.4" r="1.2"/></svg>`;
  const money = c => ayasaMoney(c, false);
  const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  // the shop's words in the page's language (snippets/ayasa-i18n.liquid). The
  // Studio's card lab draws these cards without the shop's texts, so the English
  // stays here too.
  const EN = {"choose_case_for": "Choose a case for {name} on its page", "choose_case": "Choose a case on its page", "is_sold_out": "{name} is sold out", "sold_out": "Sold out", "details_of": "Details of {name}", "view_details_of": "View details of {name}", "view_in_shop": "View {name} in the shop", "details": "Details", "view_details": "View details", "view_in_shop_link": "View in shop", "coming_soon": "Coming soon", "cards_top_side": "top side", "cards_bottom_side": "bottom side", "cards_both_sides": "both sides", "cards_play": "play"};
  const tx = (k, vars) => {
    const key = k.startsWith("cards_") ? "js.cards." + k.slice(6) : "js.card_versions." + k;
    if (typeof AYASA_t === "function" && window.AYASA_T && key in window.AYASA_T) return AYASA_t(key, vars);
    return EN[k].replace(/\{(\w+)\}/g, (all, v) => (vars && v in vars ? String(vars[v]) : all));
  };
  // "Made for you. Ships 11 November 2026" is two lines on the big card
  const badgeLines = text => String(text == null ? "" : text).split(/(?<=\.)\s+/).filter(Boolean);
  // "13 top notes and 7 bottom notes": the top counts the ding, as the pan's
  // name does (E Amara 20 = 13 + 7)
  const noteCounts = m => ({ top: 1 + ((m && m.top) || []).length, bottom: ((m && m.bottom) || []).length });
  const noteWords = (k, w) => `${k} ${w} note${k === 1 ? "" : "s"}`;
  const noteCount = m => { const c = noteCounts(m); return c.bottom ? `${noteWords(c.top, "top")} and ${noteWords(c.bottom, "bottom")}` : noteWords(c.top, "top"); };
  const noteCountHTML = m => {
    const c = noteCounts(m);
    const n = (k, w) => `<b>${k}</b> ${w} note${k === 1 ? "" : "s"}`;
    return c.bottom ? `${n(c.top, "top")} and ${n(c.bottom, "bottom")}` : n(c.top, "top");
  };
  // the struck-through old price sits before the live one, as in the shop
  const priceHTML = p => `${p.compare_at_price && p.compare_at_price > p.price ? `<s>${money(p.compare_at_price)}</s>` : ""}${money(p.price)}`;

  // The version per placement: the saved one, and on a preview host ?cards=
  // on top ("?cards=home:cards,explore:classic-a"; "home:house" shows today).
  // An unknown placement or id is dropped, which leaves that placement as today.
  function chosen() {
    const cfg = (typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.cardVersions) || {};
    const out = {};
    const put = (k, v) => {
      // "house" is the name generation 1 used for today's card, wherever it is
      if (!has(PLACES, k) || (v !== "house" && !IDS.includes(v))) return;
      if (v === "house" || v === TODAY[k]) delete out[k]; else out[k] = v;
    };
    for (const k of Object.keys(PLACES)) if (has(cfg, k)) put(k, cfg[k]);
    try {
      if (typeof location !== "undefined" && PREVIEW.test(location.hostname)) {
        const q = new URLSearchParams(location.search).get("cards");
        if (q) for (const pair of q.split(",")) { const [k, v] = pair.split(":").map(s => s.trim()); put(k, v); }
      }
    } catch (e) {}
    return out;
  }

  const modelOf = card => {
    const name = card.querySelector(".model-head h3, h3")?.textContent?.trim();
    const all = typeof MODELS !== "undefined" ? MODELS : [];
    return name ? all.find(m => m.name === name) || null : null;
  };
  // the page this card sends a buyer to: RRP-only (dealer) cards have none,
  // exactly as the house card decides
  const shopHandle = m => (!m.rrp && m.productHandle) || null;
  // core's cached /products/<handle>.js, so a card never asks twice
  const product = handle => (typeof fetchProduct === "function"
    ? fetchProduct(handle)
    : fetch(`/products/${handle}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null));

  const cartLink = (cls, m, h) =>
    `<a class="${cls}" href="/products/${esc(h)}#buyForm" aria-label="${esc(tx("choose_case_for", { name: m.name }))}" title="${esc(tx("choose_case"))}">${CART}</a>`;
  const soldOut = (cls, m) =>
    `<button type="button" class="${cls}" disabled aria-label="${esc(tx("is_sold_out", { name: m.name }))}" title="${esc(tx("sold_out"))}">${CART}</button>`;

  function foot(card) {
    let f = card.querySelector(".model-foot");
    if (!f) { f = document.createElement("div"); f.className = "model-foot"; card.appendChild(f); }
    return f;
  }
  function paintBadge(b, text, twoLines) {
    if (twoLines) b.innerHTML = badgeLines(text).map(w => `<span class="l">${esc(w)}</span>`).join("");
    else b.textContent = text;
  }
  // Core fills the house badge from the shop a moment later
  // (loadCardAvailability), so that node is replaced, never reused: its late
  // write lands on the detached one. The new badge is filled from the same
  // cached product below.
  function freshBadge(card, f, m, twoLines) {
    const old = f.querySelector(".badge");
    const b = document.createElement("span");
    b.className = `badge ${m.inStock ? "badge-stock" : "badge-order"}`;
    paintBadge(b, (old && old.textContent.trim()) || m.availability || "", twoLines);
    if (old) old.replaceWith(b); else f.prepend(b);
    return b;
  }
  // "13 top notes and 7 bottom notes" after the player's own bottom line,
  // which the player rewrites on mount and on every turn (hidden by the CSS)
  function addNoteCount(card, m) {
    if (card.querySelector(".as-notecount")) return;
    const nb = card.querySelector(".notemap-bottom");
    if (nb) nb.insertAdjacentHTML("afterend", `<p class="as-notecount">${noteCountHTML(m)}</p>`);
  }
  // A late write in a card the reader has already scrolled past (the shop's
  // date taking a third line on a narrow phone, a price wider than its room)
  // would push the page down under them. The page is scrolled by what the
  // card grew, as the browser's own scroll anchoring does where it works.
  // Where it already has, the card's bottom has not moved and nothing is
  // scrolled. A card that is not on the page (render()) is simply written.
  function steady(card, write) {
    const f = card.isConnected && card.querySelector(".model-foot");
    const above = !!f && f.getBoundingClientRect().top < 0;
    const before = above ? card.getBoundingClientRect().bottom : 0;
    write();
    if (!above) return;
    const d = card.getBoundingClientRect().bottom - before;
    if (Math.abs(d) < 0.5) return;
    // the theme scrolls smoothly (html { scroll-behavior: smooth }), and this
    // correction must not be seen
    const html = document.documentElement, was = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollBy(0, d);
    html.style.scrollBehavior = was;
  }
  // the price, the date and a sold-out cart arrive from the shop
  function fill(card, m, badge, twoLines, cartCls) {
    if (!m.productHandle) return;
    product(m.productHandle).then(p => {
      // no answer: the data file's words stay, and the price's room stays
      // empty rather than closing up under the reader
      if (!p) return;
      steady(card, () => {
        const slot = card.querySelector(".as-price:empty, .as-cprice:empty");
        // Still this card's badge? A card that was put back (upgrade's catch)
        // has its house badge again, which core fills. A card from render()
        // may not be on the page yet, and its badge is filled all the same.
        if (typeof availabilityFromProduct === "function" && card.contains(badge)) {
          const a = availabilityFromProduct(p);
          badge.classList.remove("badge-stock", "badge-order", "badge-soldout");
          badge.classList.add(a.cls);
          paintBadge(badge, a.text, twoLines);
        }
        if (slot && typeof p.price === "number") slot.innerHTML = priceHTML(p);
        if (!p.available && cartCls) {
          const cart = card.querySelector(`a.${cartCls}`);
          if (cart) cart.outerHTML = soldOut(cartCls, m);
        }
      });
    }).catch(e => console.error("card versions:", e));
  }

  // The play runs the player will draw under the big card's pan, from the
  // same facts it decides by (ayasa-cards-3.js, mountCard): three runs when
  // the instrument turns over to a photographed bottom side, else one.
  const runLabels = m => {
    const p = m.pan || {};
    const flips = !!(p.preset && p.preset.flip && p.render && p.render.bottom && p.render.bottom.src && (m.bottom || []).length);
    return flips ? [tx("cards_top_side"), tx("cards_bottom_side"), tx("cards_both_sides")] : [tx("cards_play")];
  };

  // big ("cards"): Roy's cardHTML, applied to the card core drew
  function big(card, m) {
    const h = shopHandle(m);
    card.classList.add("as-card", "as-big");
    // the card is no longer one big link: Details is
    card.classList.remove("model-card-linked");
    addNoteCount(card, m);
    const f = foot(card);
    let actions = card.querySelector(".model-actions");
    if (!actions) { actions = document.createElement("div"); actions.className = "model-actions"; f.before(actions); }
    const badge = freshBadge(card, f, m, true);
    if (m.rrp) { fill(card, m, badge, true, null); return; }   // RRP-only: keeps its RRP, no cart
    // the house link may still have a price on its way to it: removed, not reused
    f.querySelectorAll(".model-link, .model-price").forEach(el => el.remove());
    if (!h) { f.insertAdjacentHTML("beforeend", `<span class="model-price">${esc(tx("coming_soon"))}</span>`); return; }
    // Details in the bottom row, above the price and the cart (Ralf, 30-09), as
    // the shop's big card has it. data-priced: the Keep exploring and artist
    // rails turn a .model-link into a price (swapLinkPrices); not this one
    f.insertAdjacentHTML("beforeend", `<div class="as-buy"><a class="model-link as-details" href="/products/${esc(h)}" data-priced="1" aria-label="${esc(tx("details_of", { name: m.name }))}">${esc(tx("details"))} <span class="arrow" aria-hidden="true">→</span></a>` +
      `<div class="as-buy-row"><span class="model-price as-price" data-priced="1"></span>${cartLink("as-cart", m, h)}</div></div>`);
    fill(card, m, badge, true, "as-cart");
  }

  // corner ("classic-a/b/c"): Roy's classicCard, applied to the card core drew
  function corner(card, m, order) {
    const h = shopHandle(m);
    card.classList.add("as-card", "as-classic");
    addNoteCount(card, m);
    const f = foot(card);
    const badge = freshBadge(card, f, m, false);
    if (!h) { fill(card, m, badge, false, null); return false; }   // Elements "Coming soon", RRP: no corner
    f.querySelectorAll(".model-link, .model-price").forEach(el => el.remove());
    f.insertAdjacentHTML("beforeend",
      `<a class="model-link" href="/products/${esc(h)}" data-priced="1" aria-label="${esc(tx("view_details_of", { name: m.name }))}">${esc(tx("view_details"))} <span class="arrow" aria-hidden="true">→</span></a>`);
    card.classList.add("model-card-linked");
    const box = document.createElement("div");
    box.className = "as-corner";
    const heart = card.querySelector(".shortlist-heart");
    for (const k of order) {
      if (k === "heart") { if (heart) box.appendChild(heart); }
      else box.insertAdjacentHTML("beforeend", k === "price" ? `<span class="as-cprice" data-priced="1"></span>` : cartLink("as-cart2", m, h));
    }
    card.prepend(box);
    card.classList.add("as-cornered");
    fill(card, m, badge, false, "as-cart2");
    return !!heart;
  }

  // core's price words ("€4.500,00"), the same as its rails show
  const priceWords = h => (typeof fetchPrice === "function"
    ? fetchPrice(h)
    : product(h).then(p => (p ? ayasaMoney(p.price, true) : "")));

  // A house version: the link at the right of the foot, as `version` has it.
  // A new node in place of core's (core may still have a price on its way to
  // the old one), marked data-priced so core's rail pass leaves it alone. A
  // card with no shop page (RRP, coming soon) has no link, and stays as it is.
  function houseLink(card, version) {
    const kind = LINK[version];
    if (!kind || !card || !card.classList || !card.classList.contains("model-card")) return false;
    if (card.closest("#ayshop") || card.dataset.cv) return false;
    const old = card.querySelector(".model-foot .model-link");
    const h = old && ((old.getAttribute("href") || "").match(/\/products\/([^/?#]+)/) || [])[1];
    if (!h) return false;
    const name = card.querySelector(".model-head h3, h3")?.textContent?.trim() || "";
    const t = document.createElement("template");
    if (kind === "shop") {
      t.innerHTML = `<a class="model-link" href="/products/${esc(h)}" data-priced="1" aria-label="${esc(tx("view_in_shop", { name }))}">${esc(tx("view_in_shop_link"))} <span class="arrow">→</span></a>`;
    } else if (kind === "price") {
      t.innerHTML = `<a class="model-link model-link-price" href="/products/${esc(h)}" data-priced="1" aria-label="${esc(tx("view_in_shop", { name }))}"></a>`;
    } else {
      t.innerHTML = `<span class="cv-link-stack"><a class="model-link" href="/products/${esc(h)}" data-priced="1" aria-label="${esc(tx("details_of", { name }))}">${esc(tx("details"))} <span class="arrow">→</span></a><span class="model-price cv-link-price" data-priced="1"></span></span>`;
    }
    const node = t.content.firstElementChild;
    old.replaceWith(node);
    const target = kind === "price" ? node : kind === "details" ? node.querySelector(".cv-link-price") : null;
    if (target) priceWords(h).then(w => { target.textContent = w; }).catch(() => {});
    card.dataset.cv = version;
    return true;
  }

  let heartsMoved = false;
  const held = [];
  // Changes one house card into `version`, in place. False when it did not:
  // the house card, an unknown id, a card in the shop, or one already changed.
  // A card that fails half way is put back as it was, so the worst case is
  // the house card.
  function upgrade(card, version, place) {
    if (!card || !card.classList || !card.classList.contains("model-card")) return false;
    if (version !== "cards" && !has(CORNER, version)) return false;
    if (card.closest("#ayshop") || card.dataset.cv) return false;
    const m = modelOf(card);
    if (!m) return false;
    // Put back node for node, not from its HTML: core still has writes on
    // their way to some of these nodes (the rail's link price, the badge's
    // shop words), and a copy rebuilt from HTML would never receive them.
    const kept = [card, ...card.querySelectorAll("*")].map(el => [el, [...el.childNodes]]);
    const was = { cls: card.className, style: card.getAttribute("style") };
    try {
      if (version === "cards") big(card, m);
      else if (corner(card, m, CORNER[version])) heartsMoved = true;
      // the box the studio chose, set now rather than when the pan mounts, so
      // the room held for the pan below is the room it takes
      const boxH = typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.cardHeight;
      if (m.pan && boxH) card.style.setProperty("--card-h", boxH + "px");
      // the room the pan and its Full Player pill will take, held until they
      // mount (the held sizes assume the runs beside the pan, as every preset
      // has them today). Only on a page: a card from render() is mounted, or
      // not, by whoever asked for it.
      if (place !== "render" && m.pan && m.pan.preset && m.pan.preset.runs === "beside") {
        card.classList.add("cv-hold");
        if (m.pan.preset.panWidth) card.style.setProperty("--panw", m.pan.preset.panWidth + "rem");
        // The pill's stand-in is the element the player adds (a button with
        // the same words), so the row wraps exactly where it will with the
        // real one. Hidden, and out of reach of clicks, keys and readers.
        const actions = card.querySelector(".model-actions");
        if (actions && !actions.querySelector(".fp-btn, .cv-fp-hold")) actions.insertAdjacentHTML("beforeend",
          `<button type="button" class="hear-btn cv-fp-hold" tabindex="-1" aria-hidden="true" inert><span class="hear-play" aria-hidden="true">3D</span>Full Player</button>`);
        // The big card's runs sit under its pan, and on most phones (360 px
        // and narrower) they wrap onto a second row. So their room is held by
        // the same buttons, hidden, not by a fixed height. The player puts its
        // slot in front of this row, and the CSS shows the row only while
        // that slot is empty.
        const map = card.querySelector(".notemap");
        if (map && version === "cards" && !map.querySelector(".cv-runs-hold")) map.insertAdjacentHTML("afterbegin",
          `<div class="pan-runs cv-runs-hold" aria-hidden="true" inert>${runLabels(m).map(l => `<button type="button" tabindex="-1">▶ ${esc(l)}</button>`).join("")}</div>`);
        // The player module can land after the cards are painted (it is one
        // more round trip, and pan2d.js one after that). Until it takes the
        // note map, the pan's square is held by a stand-in in the place of
        // core's small drawing, so the card has its final size from here on.
        if (map && !map.querySelector(".cv-pan-hold")) map.insertAdjacentHTML("afterbegin", `<div class="cv-pan-hold" aria-hidden="true"></div>`);
        held.push({ card, m });
      }
      card.dataset.cv = version;
      card.dataset.cvPlace = place || "page";
      return true;
    } catch (e) {
      console.error("card versions:", e);
      for (const [el, nodes] of kept) el.replaceChildren(...nodes);
      card.className = was.cls;
      if (was.style == null) card.removeAttribute("style"); else card.setAttribute("style", was.style);
      delete card.dataset.cv;
      delete card.dataset.cvPlace;
      return false;
    }
  }

  // One card of a version, for the studio and Card lab: the house card for m
  // (modelCard from core), changed. Returns the element, not its HTML: the
  // price and the date are filled into it when they arrive.
  function render(version, m) {
    if (typeof modelCard !== "function" || !m) return null;
    const t = document.createElement("template");
    t.innerHTML = modelCard(m).trim();
    const card = t.content.firstElementChild;
    // nobody observes it for the reveal fade, so it starts visible
    card.classList.remove("reveal");
    if (has(LINK, version)) houseLink(card, version);
    else if (version !== "house") upgrade(card, version, "render");
    return card;
  }

  if (typeof window !== "undefined") {
    window.AyasaCardVersions = { ids: IDS.slice(), places: Object.keys(PLACES), upgrade, render, chosen, money, badgeLines, noteCount };
  }

  // ---------- the instrument's size, per version ----------
  // the shop's own layouts too, the merged card among them (ayasa-shop-15)
  // the merged row (ayasa-shop-21): the merged cards in the shop's rows view
  const SIZE_BASE = IDS.concat(["grid", "grid-v2", "list", "merge", "merge-row"]);
  // generation 8 ("card sizes: 3"): the merged card's tonality, notes count and labels
  // generation 10 ("card sizes: 5"): the description, and the Watch / Full Player buttons
  // and "around": the buttons around the pan always (1, today) or on hover only (0.5)
  const PARTS = { "": "pan", title: "tt", sub: "ts", details: "td", tone: "tn", count: "tc", labels: "tl", desc: "tx", btns: "tb", around: "ta" };
  const SIZE_IDS = SIZE_BASE.flatMap(id => Object.keys(PARTS).map(p => (p ? `${id}.${p}` : id)));
  // "cards" is --cv-pan-cards, "cards.title" --cv-tt-cards
  const sizeVar = (k, id) => { const [v, p = ""] = k.split("."); return `--cv-${PARTS[p]}-${id || v}`; };
  // the saved factors, and on a preview host ?sizes= in percent on top
  // ("?sizes=cards:130,grid:90"); 1 is today and needs nothing
  function sizes() {
    const cfg = (typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.cardSizes) || {};
    const out = {};
    const put = (k, f) => {
      if (!SIZE_IDS.includes(k) || !(f >= 0.5 && f <= 2)) return;
      if (f === 1) delete out[k]; else out[k] = f;
    };
    for (const k of Object.keys(cfg)) if (has(cfg, k)) put(k, +cfg[k]);
    try {
      if (typeof location !== "undefined" && PREVIEW.test(location.hostname)) {
        const q = new URLSearchParams(location.search).get("sizes");
        if (q) for (const pair of q.split(",")) { const [k, v] = pair.split(":").map(s => s.trim()); put(k, Math.round(+v) / 100); }
      }
    } catch (e) {}
    return out;
  }
  // The shop draws one corner card at a time, the one its file picks for this
  // screen (ayasa-shop-N.js: LAYOUT), so its size is that letter's.
  function shopCorner() {
    try {
      const sl = (typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.shopLayout) || {};
      const phone = matchMedia("(max-width: 900px)").matches;
      let v = phone ? sl.phone : sl.desktop;
      if (PREVIEW.test(location.hostname)) v = new URLSearchParams(location.search).get(phone ? "phone" : "desktop") || v;
      return /^classic-[abc]$/.test(v || "") ? v : null;
    } catch (e) { return null; }
  }
  try {
    const s = sizes(), ids = Object.keys(s);
    if (ids.length) {
      const root = document.documentElement;
      for (const id of ids) root.style.setProperty(sizeVar(id), String(s[id]));
      const c = shopCorner();
      if (c) for (const p of Object.keys(PARTS)) { const k = p ? `${c}.${p}` : c; if (has(s, k)) root.style.setProperty(sizeVar(k, "shop-classic"), String(s[k])); }
      root.classList.add("cv-sized");
    }
  } catch (e) { console.error("card versions:", e); }

  // the shop's grid tile v2, on the screen that draws it; on a preview host
  // ?cards=shopGrid:grid-v2 or shopPhone:grid-v2 shows it too
  try {
    const cv = (typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.cardVersions) || {};
    const shop = { shopGrid: cv.shopGrid, shopPhone: cv.shopPhone };
    if (typeof location !== "undefined" && PREVIEW.test(location.hostname)) {
      const q = new URLSearchParams(location.search).get("cards");
      if (q) for (const pair of q.split(",")) { const [k, v] = pair.split(":").map(s => s.trim()); if (has(shop, k)) shop[k] = v; }
    }
    // nothing chosen, nothing looked at: not even the screen's width
    if (shop.shopGrid === "grid-v2" || shop.shopPhone === "grid-v2") {
      const phone = matchMedia("(max-width: 900px)").matches;
      if ((phone ? shop.shopPhone : shop.shopGrid) === "grid-v2") document.documentElement.classList.add("cv-round-cart");
    }
  } catch (e) { console.error("card versions:", e); }

  const want = chosen();
  const places = Object.keys(want);
  // today's pages: not one read of the document
  if (!places.length) return;

  for (const place of places) {
    for (const sel of PLACES[place]) {
      document.querySelectorAll(`${sel} > .model-card`).forEach(card => {
        try {
          if (has(LINK, want[place])) houseLink(card, want[place]);
          else upgrade(card, want[place], place);
        } catch (e) { console.error("card versions:", e); }
      });
    }
  }
  // the hearts were synced once, before the corner cards moved them
  if (heartsMoved) try { if (typeof refreshShortlistUI === "function") refreshShortlistUI(); } catch (e) {}
  if (held.length) try { watchHolds(held); } catch (e) { console.error("card versions:", e); }

  // A hold ends when the pan mounts: each stand-in is removed as the real
  // thing it stands for arrives (the slot, the runs in it, the Full Player
  // pill), so no browser has to rely on the stylesheet hiding them. When the
  // pan never comes, the card lets go of the room and falls back small, as the
  // house card does. The player module did not run (no slot by
  // DOMContentLoaded, which waits for it); or it failed half way through a
  // card (marked .pan-card, slot still empty); or the definition came back
  // without one, which is told by its resource timing entry, with a moment's
  // grace for the player to read it.
  function watchHolds(list) {
    const STANDS = ".cv-pan-hold, .cv-runs-hold, .cv-fp-hold";
    const watching = new Map();
    const done = card => { watching.get(card)?.disconnect(); watching.delete(card); };
    const release = card => {
      done(card);
      card.classList.remove("cv-hold");
      card.querySelectorAll(STANDS).forEach(el => el.remove());
    };
    const drop = (card, sel) => card.querySelectorAll(sel).forEach(el => el.remove());
    const settle = card => {
      const slot = card.querySelector(".pan-slot");
      if (!slot) return;
      // The player marks the card .pan-card and fills the slot in one go, so
      // a marked card with an empty slot is one it failed on half way.
      if (card.classList.contains("pan-card") && !slot.children.length) { release(card); return; }
      drop(card, ".cv-pan-hold");
      if (slot.querySelector(".pan-runs")) drop(card, ".cv-runs-hold");
      if (card.querySelector(".model-actions .fp-btn")) drop(card, ".cv-fp-hold");
      if (slot.children.length && !card.querySelector(STANDS)) { done(card); card.classList.remove("cv-hold"); }
    };
    if (typeof MutationObserver === "function") for (const { card } of list) {
      const mo = new MutationObserver(() => settle(card));
      mo.observe(card, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
      watching.set(card, mo);
    }
    const stuck = card => card.classList.contains("cv-hold") && !!card.querySelector(".pan-slot:empty");
    const noSlot = () => list.forEach(({ card }) => { if (card.classList.contains("cv-hold") && !card.querySelector(".pan-slot")) release(card); });
    // This file is deferred, so it runs while the document is already
    // "interactive" but before DOMContentLoaded; load is the backstop.
    if (document.readyState === "complete") noSlot();
    else { document.addEventListener("DOMContentLoaded", noSlot, { once: true }); addEventListener("load", noSlot, { once: true }); }
    if (typeof PerformanceObserver !== "function") return;
    const byUrl = new Map();
    for (const { card, m } of list) {
      let u;
      try { u = new URL(m.pan.def, location.href).href; } catch (e) { continue; }
      if (!byUrl.has(u)) byUrl.set(u, []);
      byUrl.get(u).push(card);
    }
    const po = new PerformanceObserver(got => got.getEntries().forEach(en => {
      const cards = byUrl.get(en.name);
      if (!cards) return;
      byUrl.delete(en.name);
      setTimeout(() => cards.forEach(c => { if (stuck(c)) release(c); }), 1500);
      if (!byUrl.size) po.disconnect();
    }));
    try { po.observe({ type: "resource", buffered: true }); } catch (e) {}
  }
})();
